import * as React from 'react';
/**
 * This hook is for creating a state which can either be controlled or uncontrolled.
 */
export default function useControlled(_ref) {
  var {
    default: defaultValueProp,
    controlled: valueProp
  } = _ref;
  var isControlled = valueProp !== undefined;
  var {
    current: wasControlled
  } = React.useRef(isControlled);
  var hasWarned = React.useRef(false);
  var [defaultValue, setDefaultValue] = React.useState(defaultValueProp);
  var value = wasControlled ? valueProp : defaultValue;
  React.useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      if (wasControlled && !isControlled && !hasWarned.current) {
        console.warn('A component is changing a controlled input to be uncontrolled. ' + 'This is likely caused by the value changing from a defined to ' + 'undefined, which should not happen. ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://react.dev/link/controlled-components');
        hasWarned.current = true;
      }
      if (!wasControlled && isControlled && !hasWarned.current) {
        console.warn('A component is changing an uncontrolled input to be controlled. ' + 'This is likely caused by the value changing from undefined to ' + 'a defined value, which should not happen. ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://react.dev/link/controlled-components');
        hasWarned.current = true;
      }
    }
  }, [wasControlled, isControlled]);
  var setUncontrolledValue = React.useCallback(newValue => {
    if (!wasControlled) {
      setDefaultValue(newValue);
    }
  }, [wasControlled]);
  return [value, setUncontrolledValue, wasControlled];
}